import React from 'react'
import { Button } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { useNavigate } from 'react-router-dom'
import { useTenant } from '@emerald-works-nova/auth'
import TenantLogo from '../../../components/tenant-logo'
import { MindtoolsM } from '../icons'

const useStyles = makeStyles(({ spacing }) => ({
  logoButton: {
    padding: spacing(0.5),
    minWidth: 'auto',
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  logoImage: {
    height: 32,
    width: 'auto'
  },
  // Ensures SVG logos render white on colored backgrounds
  logoImageWhite: {
    filter: 'brightness(0) invert(1)'
  }
}))

export const PaidConsumerNavLogo = ({ onClose, isMobile = false, white = false }) => {
  const classes = useStyles()
  const navigate = useNavigate()
  const tenant = useTenant()

  const handleLogoClick = () => {
    navigate('/home')
    // Close mobile drawer if onClose prop is provided
    if (onClose) {
      onClose()
    }
  }

  return (
    <Button
      onClick={handleLogoClick}
      className={classes.logoButton}
      data-test='paid-consumer-nav-logo'
      aria-label='Go to homepage'
    >
      {isMobile
        ? (
          <MindtoolsM
            height={32}
            className={classes.logoImage}
          />
          )
        : (
          <TenantLogo
            tenant={tenant}
            height={32}
            mtLogo='mt-club'
            className={`${classes.logoImage} ${white ? classes.logoImageWhite : ''}`}
          />
          )}
    </Button>
  )
}
